import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";

/**
 * Text-like input primitive. Raw `<input>` is out of spec in component
 * code (design.md §10); reach for this instead.
 *
 * The px-4 inner padding is required so the mx-4 on FormField's label/error
 * lines up with the input's text content rather than its rounded edge.
 */
export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = "text", ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        "h-10 w-full px-4 type-body-base",
        "rounded-lg border border-border",
        "glass-surface-subtle text-text placeholder:text-text-muted",
        "focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        className,
      )}
      {...props}
    />
  );
});
